/* Primera Vela · tema de Shopify.
   Sale de tienda/assets/js/tienda.js (la maqueta). El carrito usa la API de Shopify (/cart.js).
   Producto digital: el carrito tiene 0 o 1 unidad, y la casilla de contenido digital es obligatoria. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const eur = (n, d = 2) => n.toLocaleString('es-ES', { minimumFractionDigits: d, maximumFractionDigits: d }) + ' €';
  const eurCents = c => eur(c / 100, c % 100 ? 2 : 0);
  const PV = window.PV || {};
  const R = PV.rutas || { carrito: '/cart', anadir: '/cart/add', cambiar: '/cart/change', actualizar: '/cart/update', pago: '/checkout' };
  const json = (url, body) => fetch(url + '.js', {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin'
  }).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.description || d.message || 'Error ' + r.status); return d; });

  /* ---------- aviso flotante ---------- */
  let tt;
  function say(msg) { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2800); }

  /* ---------- cabecera ---------- */
  const onScroll = () => { const h = $('.site-head'); h && h.classList.toggle('scrolled', scrollY > 8); };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  document.addEventListener('click', e => {
    const btn = e.target.closest('#menu-btn');
    const mnav = $('#mnav');
    if (btn && mnav) { const open = mnav.hidden; mnav.hidden = !open; btn.setAttribute('aria-expanded', String(open)); return; }
    if (mnav && !mnav.hidden && e.target.closest('#mnav a')) { mnav.hidden = true; const b = $('#menu-btn'); b && b.setAttribute('aria-expanded', 'false'); }
  });

  /* enlaces a anclas de esta misma página (/#temario estando en /): desplazar sin recargar */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.hasAttribute('data-buy') || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const dest = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!dest) return;
    e.preventDefault();
    dest.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    history.replaceState(null, '', url.hash);
  });

  /* ---------- carrito ---------- */
  let cart = null, lastFocus = null, busy = false;
  const drawer = () => $('#drawer'), scrim = () => $('#scrim');

  function setCount(n) { $$('.cart-count').forEach(c => { c.textContent = n; c.hidden = !n; }); }
  function itemImg(it) {
    if (!it.image) return PV.portada || '';
    try { const u = new URL(it.image, location.href); u.searchParams.set('width', '160'); return u.href; } catch (e) { return it.image; }
  }
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  function renderCart() {
    const body = $('#dr-body'), foot = $('#dr-foot');
    if (!body || !cart) return;
    setCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = `<div class="dr-empty"><p style="margin:0">Tu carrito está vacío.</p><a class="btn ghost" href="/#comprar" data-close-cart>Ver el manual</a></div>`;
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(it => `
      <div class="line-item">
        <img src="${esc(itemImg(it))}" alt="${esc(it.product_title)}" width="76" height="76" style="aspect-ratio:1/1;object-fit:cover">
        <div><b>${esc(it.product_title)}</b>${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}<button class="rm" type="button" data-remove="${esc(it.key)}">Quitar</button></div>
        <span class="pr">${eurCents(it.final_line_price)}</span>
      </div>`).join('') + `
      <div class="dr-note"><svg class="i"><use href="#i-bolt"/></svg><span>Producto digital: no hay envío. Recibes el acceso por email en cuanto se confirma el pago.</span></div>
      <div class="dr-note"><svg class="i"><use href="#i-shield"/></svg><span>Garantía de 14 días. Si el manual no te sirve, te devolvemos el dinero.</span></div>`;
    foot.hidden = false;
    $('#dr-sub').textContent = eurCents(cart.total_price);
  }
  async function loadCart() { cart = await json(R.carrito); renderCart(); return cart; }

  function openCart() {
    const d = drawer(), s = scrim();
    if (!d) { location.href = R.carrito; return; }
    lastFocus = document.activeElement;
    s.hidden = false; d.hidden = false;
    requestAnimationFrame(() => { s.classList.add('on'); d.classList.add('on'); });
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const x = $('#dr-close'); x && x.focus(); }, 60);
  }
  function closeCart() {
    const d = drawer(), s = scrim();
    if (!d || d.hidden) return;
    s.classList.remove('on'); d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(() => { s.hidden = true; d.hidden = true; }, 300);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  /* añade el manual (una sola unidad) y abre el carrito */
  async function buy(variantId, btn) {
    if (busy) return;
    busy = true; btn && btn.classList.add('loading');
    try {
      const c = await json(R.carrito);
      const line = c.items.find(i => i.variant_id === variantId);
      if (!line) await json(R.anadir, { items: [{ id: variantId, quantity: 1 }] });
      else if (line.quantity > 1) await json(R.cambiar, { id: line.key, quantity: 1 });
      await loadCart();
      openCart();
    } catch (err) {
      say('No se ha podido añadir: ' + err.message);
    } finally { busy = false; btn && btn.classList.remove('loading'); }
  }

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-buy]');
    if (b && PV.variante) { e.preventDefault(); buy(PV.variante, b); return; }
    const o = e.target.closest('[data-open-cart]');
    if (o && drawer()) { e.preventDefault(); openCart(); loadCart().catch(() => { location.href = R.carrito; }); return; }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) {
      rm.disabled = true;
      json(R.cambiar, { id: rm.dataset.remove, quantity: 0 }).then(c => { cart = c; renderCart(); say('Has quitado el manual del carrito'); }).catch(err => say(err.message));
      return;
    }
    if (e.target.closest('#scrim') || e.target.closest('#dr-close')) closeCart();
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  /* formularios de producto (sección Compra): mismo comportamiento que los botones */
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-pv-buy]');
    if (!f) return;
    e.preventDefault();
    const id = +new FormData(f).get('id');
    buy(id || PV.variante, $('button[type=submit]', f));
  });

  /* finalizar compra: casilla obligatoria, se guarda en el pedido y se va al pago */
  document.addEventListener('change', e => {
    if (e.target.id !== 'dr-consent') return;
    const err = $('#dr-err');
    if (e.target.checked && err) { err.hidden = true; e.target.closest('.check').classList.remove('need'); }
  });
  document.addEventListener('click', async e => {
    const go = e.target.closest('#dr-checkout');
    if (!go) return;
    const ok = $('#dr-consent'), err = $('#dr-err');
    if (!ok.checked) {
      err.textContent = 'Para continuar, marca la casilla: es obligatoria en los productos digitales.';
      err.hidden = false; ok.closest('.check').classList.add('need'); ok.focus();
      return;
    }
    go.classList.add('loading');
    try {
      await json(R.actualizar, { attributes: { [go.dataset.atributo]: go.dataset.valor } });
      location.href = R.pago;
    } catch (x) {
      go.classList.remove('loading');
      err.textContent = 'No se ha podido continuar: ' + x.message; err.hidden = false;
    }
  });

  /* al volver con el botón «atrás», el número del carrito puede estar desfasado */
  addEventListener('pageshow', e => { if (e.persisted) json(R.carrito).then(c => { cart = c; setCount(c.item_count); renderCart(); }).catch(() => {}); });

  /* ---------- secciones (se reinician al editarlas en el editor de temas) ---------- */
  function initTour(root) {
    $$('[data-tour]', root).forEach(tour => {
      const tabs = $$('.tab', tour);
      const img = $('[data-tour-img]', tour), cap = $('[data-tour-cap]', tour), mdesc = $('[data-tour-desc]', tour);
      tabs.forEach(t => { const i = new Image(); i.src = t.dataset.img; });
      function select(t, focus) {
        tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
        img.src = t.dataset.img; img.alt = t.dataset.alt; cap.textContent = t.dataset.cap;
        if (mdesc) mdesc.textContent = $('p', t).textContent;
        if (focus) t.focus();
      }
      tabs.forEach((t, k) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', e => {
          const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
          if (d) { e.preventDefault(); select(tabs[(k + d + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* ejercicio en vivo: tamaño de la posición (módulo 11) */
  function initCalc(root) {
    $$('[data-calc]', root).forEach(calc => {
      const q = n => $(`[data-c="${n}"]`, calc);
      const cap = q('cap'), risk = q('risk'), entry = q('entry'), stop = q('stop');
      const riskOut = q('risk-out'), svg = q('viz'), leg = q('legend');
      const oShares = q('shares'), oRisk = q('o-risk'), oNot = q('o-not'), read = q('read');
      const num = el => parseFloat(String(el.value).replace(',', '.'));
      function draw(E, S) {
        const T = E + 2 * (E - S);
        const lo = S - (E - S) * .6, hi = T + (E - S) * .45;
        const W = 420, H = 250, L = 4, Rr = W - 4;
        const y = v => 10 + (hi - v) / (hi - lo) * (H - 20);
        // recorrido de ejemplo: entra, retrocede sin tocar el stop y sube hacia el objetivo
        const path = [0, .15, -.35, .1, -.55, .2, .6, .35, .9, 1.25, 1.05, 1.5, 1.75];
        const x1 = L + 14, x2 = W * .52;
        const pts = path.map((p, i) => [x1 + i * ((x2 - x1) / (path.length - 1)), y(E + p * (E - S))]);
        const lbl = (v, txt, cls, below) => `<text x="${Rr - 4}" y="${y(v) + (below ? 15 : -7)}" text-anchor="end" class="${cls}" font-family="IBM Plex Mono, monospace" font-size="12.5">${txt}</text>`;
        svg.innerHTML = `
          <rect x="${L}" y="${y(T)}" width="${Rr - L}" height="${y(E) - y(T)}" rx="4" style="fill:var(--up-soft)"/>
          <rect x="${L}" y="${y(E)}" width="${Rr - L}" height="${y(S) - y(E)}" rx="4" style="fill:var(--down-soft)"/>
          <line x1="${L}" x2="${Rr}" y1="${y(T)}" y2="${y(T)}" style="stroke:var(--up)" stroke-width="1.5" stroke-dasharray="4 4"/>
          <line x1="${L}" x2="${Rr}" y1="${y(E)}" y2="${y(E)}" style="stroke:var(--cobalt)" stroke-width="1.8"/>
          <line x1="${L}" x2="${Rr}" y1="${y(S)}" y2="${y(S)}" style="stroke:var(--down)" stroke-width="1.5" stroke-dasharray="4 4"/>
          <polyline points="${pts.map(p => p.join(',')).join(' ')}" style="fill:none;stroke:var(--ink)" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>
          <circle cx="${pts[0][0]}" cy="${pts[0][1]}" r="4.5" style="fill:var(--cobalt)"/>
          ${lbl(T, 'Objetivo 2R · ' + eur(T), 'lt-up', true)}
          ${lbl(E, 'Entrada · ' + eur(E), 'lt-in')}
          ${lbl(S, 'Stop · ' + eur(S), 'lt-dn', true)}`;
        if (leg) leg.innerHTML = `<span>Riesgo por acción (1R): <b>${eur(E - S)}</b></span><span>Ganancia por acción si llega a 2R: <b>${eur(2 * (E - S))}</b></span>`;
      }
      function run() {
        const C = num(cap), r = parseFloat(risk.value), E = num(entry), S = num(stop);
        riskOut.textContent = r.toLocaleString('es-ES', { maximumFractionDigits: 2 }) + ' %';
        read.classList.remove('err');
        if (!(C > 0) || !(E > 0) || !(S > 0)) { read.classList.add('err'); read.textContent = 'Escribe un capital, una entrada y un stop mayores que cero.'; return; }
        if (S >= E) { read.classList.add('err'); read.textContent = 'En una compra, el stop va por debajo de la entrada. Baja el stop o sube la entrada.'; oShares.textContent = '0'; oRisk.textContent = eur(0); oNot.textContent = eur(0); return; }
        const riskEur = C * r / 100, dist = E - S, n = Math.floor(riskEur / dist), real = n * dist, notional = n * E;
        const after = C * Math.pow(1 - r / 100, 10);
        oShares.textContent = n.toLocaleString('es-ES');
        oRisk.textContent = eur(real);
        oNot.textContent = eur(notional, 0);
        draw(E, S);
        if (n === 0) { read.classList.add('err'); read.textContent = `Con ${eur(riskEur)} de riesgo y ${eur(dist)} de distancia al stop no llega ni para una acción. Acerca el stop o busca otra operación.`; return; }
        read.textContent = notional > C
          ? `La posición vale ${eur(notional, 0)}, más que tu cuenta. Necesitarías apalancamiento: el módulo 3 explica por qué eso multiplica el riesgo.`
          : `Si el precio toca el stop pierdes ${eur(real)}, el ${riskOut.textContent} de tu cuenta. Con esta regla, tras diez pérdidas seguidas aún tendrías ${eur(after, 0)}.`;
      }
      [cap, risk, entry, stop].forEach(el => el.addEventListener('input', run));
      run();
    });
  }

  function initGal(root) {
    $$('[data-gal]', root).forEach(gal => {
      const main = $('[data-gal-main]', gal);
      $$('.thumbs button', gal).forEach(b => b.addEventListener('click', () => {
        $$('.thumbs button', gal).forEach(x => x.setAttribute('aria-current', String(x === b)));
        main.src = b.dataset.src; main.alt = $('img', b).alt;
      }));
    });
  }

  /* el aviso del precio de lanzamiento se oculta solo el día indicado */
  function initLaunch(root) {
    const hoy = new Date(); const iso = hoy.getFullYear() + '-' + String(hoy.getMonth() + 1).padStart(2, '0') + '-' + String(hoy.getDate()).padStart(2, '0');
    $$('[data-hasta]', root).forEach(el => { const h = el.dataset.hasta; if (/^\d{4}-\d{2}-\d{2}$/.test(h) && iso >= h) el.hidden = true; });
  }

  /* barra fija de compra: aparece cuando no se ven ni la portada ni la sección de compra */
  let stickyObs = [];
  function initSticky() {
    stickyObs.forEach(o => o.disconnect()); stickyObs = [];
    const bar = $('#sticky-buy'), heroCta = $('#hero-cta'), buySec = $('#comprar');
    if (!bar || !('IntersectionObserver' in window)) return;
    let heroVis = !!heroCta, buyVis = false;
    const upd = () => bar.classList.toggle('on', !heroVis && !buyVis);
    if (heroCta) { const o = new IntersectionObserver(es => { heroVis = es[0].isIntersecting || es[0].boundingClientRect.top > 0; upd(); }); o.observe(heroCta); stickyObs.push(o); }
    if (buySec) { const o = new IntersectionObserver(es => { buyVis = es[0].isIntersecting || (!heroCta && es[0].boundingClientRect.top > 0); upd(); }, { rootMargin: '0px 0px -20% 0px' }); o.observe(buySec); stickyObs.push(o); }
    upd();
  }

  /* enlace «Preferencias de cookies»: abre el banner de privacidad de Shopify si está activo */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-cookies]');
    if (!a) return;
    const pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') { e.preventDefault(); pb.showPreferences(); }
  });

  function init(root = document) { initTour(root); initCalc(root); initGal(root); initLaunch(root); initSticky(); }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
